import React, { useEffect, useState } from "react";
import { Box, Button, List, ListItem, Typography } from "@mui/material";
import {
  useCourseRenderingCourseInt,
  useCourseRenderingDetails,
  useCourseRenderingLoading,
  useCourseScoreCardDetails,
} from "hooks/CourseMapDetails";
import { useProfileData } from "hooks/ProfileDetails";
import asset from "json/assets";
import events from "json/events";
import Draggable from "react-draggable";
import { useDispatch } from "react-redux";
import { details_coursemap_rendering } from "redux/CourseMapSlice";
import eventEmitter from "services/event.emitter";
import { decryptSecretKey } from "services/utils";
import styles from "styles/component/CustomCoursePopOver.module.scss";
import _styles from "styles/component/CourseMapInfoPopOver.module.scss";
import { useNavigate } from "react-router-dom";
import LaunchIcon from '@mui/icons-material/Launch';


export const CourseMapInfoPopOver = (props) => {
  const { title = "Course Info" ,courseID} = props;
  const ScoreCardDetails=useCourseScoreCardDetails()
  const renderingData = useCourseRenderingDetails();
  const renderingStatus = useCourseRenderingLoading();
  const renderingCourseInt = useCourseRenderingCourseInt();
  const dispatch = useDispatch();
  const profileData = useProfileData();
  const secret_Key = decryptSecretKey();
  const [open, setOpen] = useState(false);
    const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handler = (e) => setOpen(e.visible);
    eventEmitter.on(events.openCourseInfoModal, handler);
    return () => eventEmitter.off(events.openCourseInfoModal, handler);
  }, []);

  useEffect(() => {
    const closeOnAttributePopover = (e) => {
      if (e?.visible || e?.open) {
        setOpen(false);
      }
    };
    eventEmitter.on(events.addMarkerToggle, closeOnAttributePopover);
    eventEmitter.on(events.openTreeElementInModal, closeOnAttributePopover);
    eventEmitter.on(events.openBunkerElementInModal, closeOnAttributePopover);
    return () => {
      eventEmitter.off(events.addMarkerToggle, closeOnAttributePopover);
      eventEmitter.off(events.openTreeElementInModal, closeOnAttributePopover);
      eventEmitter.off(events.openBunkerElementInModal, closeOnAttributePopover);
    };
  }, []);

  useEffect(() => {
    if (ScoreCardDetails?.courseName && renderingStatus !== "loading") {
      setOpen(true);
    }
  }, [ScoreCardDetails?.courseName, renderingStatus]);

  useEffect(() => {
    dispatch(
      details_coursemap_rendering({
        body: {
          id_courseInt: Number(courseID),
        },
        user: {
          secretKey: secret_Key,
          userName: profileData?.profile_information_data?.username,
        },
      })
    );
  }, [courseID]);

  const locationLine = [
    ScoreCardDetails?.city,
    ScoreCardDetails?.stateShort,
    ScoreCardDetails?.countryShort,
  ]
    .filter(Boolean)
    .join(", ");

  const renderingElements =
    renderingData?.Status === 1 &&
    Array.isArray(renderingData?.elements) &&
    Number(renderingCourseInt) === Number(courseID)
      ? renderingData.elements
      : [];
  const activeRenderingElements = renderingElements.filter(
    (row) => row?.active === 1
  );
  const renderingRowItems = activeRenderingElements.map((row, index) => {
    const details = [row?.characteristic, row?.grasstype, row?.seasonality]
      .filter(Boolean)
      .join(", ");
    return (
      <Box key={index} className={_styles.rendering_row}>
        <Typography className={_styles.rendering_element}>
          {row?.elementtype}
        </Typography>
        <Typography className={_styles.rendering_details}>{details}</Typography>
      </Box>
    );
  });

  return (
    <Box className={`${styles.sub_popover} ${styles.draggableDiv}`}>
    <Draggable
  bounds="#DraggableContainer"
  defaultPosition={{ x: 0, y: 0 }}
  enableUserSelectHack={false}
  handle=".draggable-header"
>
  <Box
    id="course_info_popover"
    className={`${styles.poover_content} ${styles.default_poover_content} custom_popover_content ${_styles.info_popover}`}
    sx={{ opacity: open ? "1" : "0", display: open ? "block" : "none" }}
  >
    <Box
      className={`draggable-header ${styles.poover_head}`}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Box display="flex" alignItems="center">
        <Typography variant="h5" sx={{ margin: 0, padding: 0, lineHeight: 1 }}>
          {title}
        </Typography>
        <LaunchIcon
          onClick={() => navigate(`/editCourseInformation/course?courseId=${courseID}`)}
              sx={{
      color: "white",
      cursor: "pointer",
      ml: 0.6,
      fontSize: 19,
      verticalAlign: "middle",
    }}
        />
      </Box>

      <List sx={{ padding: 0 }}>
        <ListItem sx={{ padding: 0 }}>
          <Button onClick={handleClose}>
            <img src={asset.close} alt="close" />
          </Button>
        </ListItem>
      </List>
    </Box>

    <Box className={`${styles.popover_ftr} ${_styles.info_body}`}>
      <Box className={_styles.course_info}>
        <Typography>#{courseID} - {ScoreCardDetails?.courseName}</Typography>
        <Typography>{ScoreCardDetails?.address1}</Typography>
        <Typography>{locationLine}</Typography>
        <Typography>{ScoreCardDetails?.layoutHoles} Holes</Typography>
        <Typography>
          <a
            href={
              ScoreCardDetails?.courseURL?.startsWith("http")
                ? ScoreCardDetails.courseURL
                : `https://${ScoreCardDetails?.courseURL}`
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            {ScoreCardDetails?.courseURL}
          </a>
        </Typography>
      </Box>
      {activeRenderingElements.length ? (
        <Box className={_styles.rendering_profile}>
          <Typography className={_styles.rendering_title}>
            Rendering Profile
          </Typography>
          {renderingRowItems}
        </Box>
      ) : null}
    </Box>
  </Box>
</Draggable>
    </Box>
  );
};
